import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appResizableColumn]',
  standalone:false
})
export class ResizableColumnDirective {
  @Input() columnIndex!: number;

  private startX = 0;
  private startWidth = 0;
  private resizer!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    // Create a resizer grip
    this.resizer = this.renderer.createElement('span');
    this.renderer.setStyle(this.resizer, 'width', '5px');
    this.renderer.setStyle(this.resizer, 'cursor', 'col-resize');
    this.renderer.setStyle(this.resizer, 'position', 'absolute');
    this.renderer.setStyle(this.resizer, 'top', '0');
    this.renderer.setStyle(this.resizer, 'right', '0');
    this.renderer.setStyle(this.resizer, 'bottom', '0');
    this.renderer.setStyle(this.resizer, 'z-index', '10');
    this.renderer.appendChild(this.el.nativeElement, this.resizer);

    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.target === this.resizer) {
      this.startX = event.pageX;
      this.startWidth = this.el.nativeElement.offsetWidth;

      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove = (event: MouseEvent) => {
    const dx = event.pageX - this.startX;
    const newWidth = this.startWidth + dx;
    if (newWidth > 80) { // set a minimum width
      this.setColumnWidth(newWidth);
    }
  };

  onMouseUp = () => {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  };

  setColumnWidth(newWidth: number) {
    const table = this.el.nativeElement.closest('table');
    const index = this.columnIndex;

    // --- Update <th> ---
    (this.el.nativeElement as HTMLElement).style.width = newWidth + 'px';

    // --- Update inner .th-content div ---
    const headerDiv = this.el.nativeElement.querySelector('.th-content');
    if (headerDiv) {
      (headerDiv as HTMLElement).style.width = newWidth + 'px';
    }

    // --- Update all <td> in this column ---
    Array.from(table.querySelectorAll('tbody tr')).forEach((tr: any) => {
      const cell = tr.children[index + 1]; // +1 if you have an Actions col at 0
      if (cell) {
        (cell as HTMLElement).style.width = newWidth + 'px';
        const inner = cell.querySelector('textarea, input, div');
        if (inner) {
          (inner as HTMLElement).style.width = '100%'; // stretch inside cell
        }
      }
    });

    // Let the table grow horizontally
    (table as HTMLElement).style.width = 'auto';
  }
}
